// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0a0e27;
  --surface: #0f1428;
  --ink: #f5f7fb;
  --muted: #a7b0c0;
  --border: #1e2139;
  --yellow: #ffd200;
  /* Accent color for text/icons. In light mode, pure yellow on white fails contrast. */
  --yellow-ink: #ffd200;
  --yellow-hover: #ffe033;
  --red: #c1121f;
  --shadow: rgba(0, 0, 0, 0.35);
  --surface-rgb: 15, 20, 40;
  --radius: 1rem;
  --gradient-1: rgba(99, 102, 241, 0.1);
  --gradient-2: rgba(168, 85, 247, 0.08);
  --gradient-3: rgba(236, 72, 153, 0.06);
}

[data-theme=light] {
  --bg: #f8fafc;
  --surface: #ffffff;
  --ink: #1a1d24;
  --muted: #5c6370;
  --border: #e2e6ee;
  --shadow: rgba(0, 0, 0, 0.08);
  --surface-rgb: 255, 255, 255;
  --yellow-ink: #8a5200;
  --yellow-hover: #e6bd00;
  --gradient-1: rgba(99, 102, 241, 0.05);
  --gradient-2: rgba(168, 85, 247, 0.04);
  --gradient-3: rgba(236, 72, 153, 0.03);
}

*, *::before, *::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  color-scheme: dark;
}

[data-theme=light] {
  color-scheme: light;
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
  font-size: 16px;
  line-height: 1.6;
  color: var(--ink);
  position: relative;
  background: linear-gradient(135deg, #070a1d 0%, var(--bg) 55%, #0b1233 100%);
  background-attachment: fixed;
  text-rendering: optimizeLegibility;
  display: flex;
  min-height: 100vh;
}

[data-theme=light] body {
  background: linear-gradient(180deg, #bfe6ff 0%, #d8f0ff 45%, #f8fafc 100%);
  background-attachment: fixed;
}

body::before,
body::after {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: -1;
}

body::before {
  opacity: 0.85;
  background-image: radial-gradient(1px 1px at 25px 25px, rgba(255, 255, 255, 0.75) 60%, transparent 61%), radial-gradient(1px 1px at 80px 45px, rgba(255, 255, 255, 0.55) 60%, transparent 61%), radial-gradient(1px 1px at 60px 90px, rgba(255, 255, 255, 0.35) 60%, transparent 61%), radial-gradient(2px 2px at 110px 130px, rgba(255, 255, 255, 0.28) 60%, transparent 61%);
  background-size: 160px 160px;
  background-position: 0 0;
  filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.18));
}

body::after {
  opacity: 1;
  background: radial-gradient(900px 500px at 15% 10%, rgba(255, 210, 0, 0.08), transparent 55%), radial-gradient(900px 500px at 85% 20%, rgba(99, 102, 241, 0.1), transparent 60%), radial-gradient(900px 600px at 50% 90%, rgba(236, 72, 153, 0.06), transparent 60%);
}

[data-theme=light] body::before {
  opacity: 0.9;
  filter: blur(0.2px);
  background: radial-gradient(220px 140px at 10% 22%, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0) 65%), radial-gradient(300px 180px at 32% 14%, rgba(255, 255, 255, 0.75) 0%, rgba(255, 255, 255, 0) 66%), radial-gradient(280px 170px at 60% 20%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 68%), radial-gradient(340px 200px at 84% 16%, rgba(255, 255, 255, 0.75) 0%, rgba(255, 255, 255, 0) 66%);
}

[data-theme=light] body::after {
  background: radial-gradient(380px 240px at 18% 38%, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0) 70%), radial-gradient(420px 260px at 55% 42%, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 72%), radial-gradient(420px 260px at 86% 46%, rgba(255, 255, 255, 0.45) 0%, rgba(255, 255, 255, 0) 72%);
  opacity: 0.75;
  filter: blur(0.6px);
}

.container {
  width: min(1100px, 92%);
  margin: 0 auto;
}

a {
  color: inherit;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  width: calc(100% - 200px);
}
@media (max-width: 900px) {
  .main-content {
    margin-left: 0;
    width: 100%;
  }
}

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 200px;
  background: rgba(var(--surface-rgb), 0.95);
  backdrop-filter: saturate(120%) blur(10px);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  z-index: 9999;
  transition: transform 0.3s ease;
}
@media (max-width: 900px) {
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.sidebar-open {
    transform: translateX(0);
  }
}

.sidebar-header {
  padding: 1.5rem 1rem 1rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-brand {
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}
.sidebar-brand .brand-avatar {
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 999px;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
  border: 1px solid rgba(255, 210, 0, 0.25);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  background: rgba(var(--surface-rgb), 0.6);
}
.sidebar-brand .brand-name {
  font-weight: 750;
  letter-spacing: -0.01em;
  color: var(--ink);
  font-size: 1rem;
  line-height: 1;
}
.sidebar-brand:hover .brand-name {
  color: var(--yellow-ink);
}

@media (max-width: 640px) {
  .sidebar-brand .brand-name {
    display: none;
  }
}
.sidebar .theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 0;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.2s ease, color 0.2s ease;
}
.sidebar .theme-toggle:hover {
  background: rgba(255, 210, 0, 0.12);
  color: var(--yellow-ink);
}
.sidebar .theme-toggle:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}
.sidebar .theme-toggle .theme-toggle-icon--sun {
  display: none;
}
.sidebar .theme-toggle .theme-toggle-icon--moon {
  display: inline;
}

[data-theme=light] .sidebar .theme-toggle .theme-toggle-icon--sun {
  display: inline;
}

[data-theme=light] .sidebar .theme-toggle .theme-toggle-icon--moon {
  display: none;
}

.sidebar-nav {
  flex: 1;
  padding: 1.5rem 0;
  overflow-y: auto;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-link {
  display: block;
  padding: 0.75rem 1rem;
  color: var(--ink);
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: background 0.2s ease, color 0.2s ease, padding-left 0.2s ease;
  border-left: 3px solid transparent;
}
.nav-link:hover {
  background: rgba(255, 210, 0, 0.08);
  color: var(--yellow-ink);
  padding-left: 1.25rem;
}
.nav-link.is-active {
  background: rgba(255, 210, 0, 0.12);
  color: var(--yellow-ink);
  border-left-color: var(--yellow-ink);
  padding-left: 1.25rem;
}

.sidebar-social {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1rem 1rem 0.5rem;
  border-top: 1px solid var(--border);
  margin-top: auto;
  /* Push to bottom if needed, though sidebar-nav has flex: 1 */
}
.sidebar-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: var(--muted);
  font-size: 1.1rem;
  border-radius: 50%;
  transition: all 0.2s ease;
}
.sidebar-social a:hover {
  color: var(--yellow-ink);
  background: rgba(255, 210, 0, 0.1);
}

.sidebar-footer-text {
  padding: 0.5rem 1rem 1.5rem;
  text-align: center;
}
.sidebar-footer-text small {
  display: block;
  color: var(--muted);
  font-size: 0.7rem;
  line-height: 1.5;
  opacity: 0.8;
}

.sidebar-toggle {
  display: none;
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 10000;
  background: rgba(var(--surface-rgb), 0.95);
  backdrop-filter: saturate(120%) blur(10px);
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  padding: 0.75rem;
  cursor: pointer;
  transition: background 0.2s ease;
}
.sidebar-toggle:hover {
  background: rgba(var(--surface-rgb), 1);
}
.sidebar-toggle:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}
.sidebar-toggle .bar {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--ink);
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.sidebar-toggle .bar + .bar {
  margin-top: 5px;
}
.sidebar-toggle[aria-expanded=true] .bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.sidebar-toggle[aria-expanded=true] .bar:nth-child(2) {
  opacity: 0;
}
.sidebar-toggle[aria-expanded=true] .bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}
@media (max-width: 900px) {
  .sidebar-toggle {
    display: block;
  }
}

.site-header {
  display: none;
}

.section {
  padding: clamp(72px, 10vh, 120px) 0;
}
.section--hero {
  min-height: 60vh;
  display: grid;
  place-items: center;
  position: relative;
  text-align: center;
  background-image: radial-gradient(1400px 400px at 10% -10%, rgba(255, 210, 0, 0.06), transparent 55%), radial-gradient(1400px 400px at 90% 10%, rgba(193, 18, 31, 0.05), transparent 55%);
  background-size: auto;
  background-position: center;
}
.section--hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--surface-rgb), 0.2);
  z-index: 1;
}
.section--hero .container {
  position: relative;
  z-index: 1;
}
.section--hero .eyebrow {
  margin: 0 0 1rem 0;
  color: var(--yellow-ink);
  letter-spacing: 0.02em;
  font-size: 0.95rem;
  font-family: "Courier New", monospace;
  font-weight: 600;
}
.section--hero .hero-heading {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 750;
  margin: 0 0 1.25rem 0;
  letter-spacing: -0.03em;
  line-height: 1.15;
}
.section--hero .hero-intro {
  color: var(--ink);
  font-size: clamp(1.05rem, 2vw, 1.2rem);
  margin: 0 auto 1.5rem;
  max-width: 70ch;
  line-height: 1.65;
}
.section--hero .hero-badges {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}
.section--hero .hero-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1.25rem;
}
.section--hero .hero-pills {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 0.75rem;
  margin-bottom: 1.25rem;
}
.section--hero .hero-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  background: rgba(var(--surface-rgb), 0.6);
  border: 1px solid var(--border);
  color: var(--ink);
  font-size: 0.9rem;
  font-weight: 650;
}
.section--hero .hero-pill i {
  color: var(--yellow-ink);
  font-size: 0.95rem;
}
.section--hero .hero-social {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
}
.section--alt {
  background: rgba(var(--surface-rgb), 0.3);
}
.section--accent {
  position: relative;
  background-image: radial-gradient(1200px 400px at 30% 10%, rgba(255, 210, 0, 0.05), transparent 55%), radial-gradient(900px 350px at 80% 100%, rgba(193, 18, 31, 0.04), transparent 55%);
}
.section--accent::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--surface-rgb), 0.4);
  z-index: 1;
}
.section--accent .container {
  position: relative;
  z-index: 1;
}

.education-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  margin-top: 1.5rem;
}
@media (max-width: 900px) {
  .education-grid {
    grid-template-columns: 1fr;
  }
}

.edu-item {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: 0 4px 16px var(--shadow);
  display: grid;
  grid-template-columns: 7.5rem 1fr;
  gap: 1rem;
  align-items: start;
}
.edu-item:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}
@media (max-width: 640px) {
  .edu-item {
    grid-template-columns: 1fr;
    text-align: left;
  }
}

.edu-logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
}

.edu-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.edu-school {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: var(--yellow-ink);
}

.edu-dates {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.7rem;
  border-radius: 999px;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.55);
  color: var(--muted);
  font-size: 0.9rem;
  font-weight: 650;
  white-space: nowrap;
}

.edu-subheader {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem 1rem;
  flex-wrap: wrap;
  margin-top: 0.45rem;
}

.edu-degree {
  color: var(--ink);
  font-size: 1rem;
  font-weight: 650;
}

.edu-loc {
  color: var(--muted);
  font-size: 0.95rem;
  font-weight: 600;
}

.edu-bullets {
  margin: 0.85rem 0 0 1.1rem;
  color: var(--ink);
}
.edu-bullets li {
  margin: 0.35rem 0;
}
.edu-bullets li strong {
  color: var(--muted);
  font-weight: 650;
}

.edu-inline-list {
  display: inline;
  color: var(--ink);
  font-weight: 600;
}

.edu-sections {
  margin-top: 1rem;
  display: grid;
  gap: 1rem;
}

.edu-section {
  border: 1px solid var(--border);
  border-radius: 0.9rem;
  padding: 0.9rem;
  background: rgba(var(--surface-rgb), 0.35);
}

.edu-section-title {
  font-size: 0.82rem;
  font-weight: 800;
  color: var(--muted);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 0.65rem;
}

.edu-course-list,
.edu-teaching-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.55rem;
}

.edu-course-list {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
@media (max-width: 640px) {
  .edu-course-list {
    grid-template-columns: 1fr;
  }
}

.edu-course-item {
  display: flex;
  gap: 0.6rem;
  align-items: baseline;
  min-width: 0;
}

.edu-course-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--ink);
  white-space: nowrap;
}

.edu-course-name {
  color: var(--ink);
  font-weight: 650;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-course-grade {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 210, 0, 0.28);
  background: rgba(255, 210, 0, 0.1);
  color: var(--yellow-ink);
  font-size: 0.82rem;
  font-weight: 800;
  white-space: nowrap;
}

.edu-teaching-item {
  color: var(--ink);
  font-weight: 650;
  line-height: 1.5;
}

.edu-teaching-role {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.55);
  color: var(--muted);
  font-size: 0.82rem;
  font-weight: 850;
  letter-spacing: 0.04em;
  margin-right: 0.25rem;
}

.edu-teaching-course {
  color: var(--ink);
  font-weight: 750;
}

.edu-teaching-term {
  color: var(--muted);
  font-weight: 650;
  white-space: nowrap;
}

.edu-actions {
  margin-top: 0.9rem;
}

body.modal-open {
  overflow: hidden;
}

.modal {
  position: fixed;
  inset: 0;
  z-index: 10060;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
}

.modal.is-open {
  display: flex;
}

.modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.modal-panel {
  position: relative;
  width: min(920px, 100%);
  max-height: min(82vh, 760px);
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.96);
  backdrop-filter: saturate(120%) blur(12px);
  box-shadow: 0 18px 55px var(--shadow);
  overflow: hidden;
  z-index: 1;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1rem 0.85rem;
  border-bottom: 1px solid var(--border);
}

.modal-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.modal-close {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.55);
  color: var(--muted);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.06s ease;
}
.modal-close:hover {
  background: rgba(255, 210, 0, 0.12);
  border-color: rgba(255, 210, 0, 0.35);
  color: var(--yellow-ink);
}
.modal-close:active {
  transform: translateY(1px);
}
.modal-close:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}

.modal-body {
  padding: 1rem;
  overflow: auto;
}

.modal .edu-course-name {
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
}

.section-header {
  margin: 0 0 2rem 0;
}

.section-title {
  margin: 0 0 0.5rem 0;
  font-size: clamp(1.5rem, 2.8vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  position: relative;
}
.section-title::before {
  content: "/ ";
  color: var(--yellow-ink);
  font-weight: 750;
}

.section-subtitle {
  margin: 0;
  color: var(--muted);
  max-width: 70ch;
  font-size: 0.98rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.8rem;
  text-decoration: none;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--ink);
  font-weight: 650;
  cursor: pointer;
  transition: transform 0.06s ease, background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.btn:hover {
  background: var(--yellow);
  color: #111;
  border-color: var(--yellow);
}
.btn:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}
.btn:active {
  transform: translateY(1px);
}
.btn--primary {
  background: var(--yellow);
  border-color: var(--yellow);
  color: #111;
}
.btn--primary:hover {
  background: var(--yellow-hover);
  border-color: var(--yellow-hover);
}
.btn--ghost {
  background: transparent;
}
.btn--ghost:hover {
  background: rgba(255, 210, 0, 0.12);
  border-color: rgba(255, 210, 0, 0.35);
  color: var(--yellow-ink);
}
.btn--small {
  padding: 0.5rem 0.75rem;
  border-radius: 0.7rem;
  font-size: 0.9rem;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  background: rgba(var(--surface-rgb), 0.6);
  border: 1px solid var(--border);
  color: var(--muted);
  font-size: 0.9rem;
  font-weight: 600;
}
.status-badge--active {
  background: rgba(255, 210, 0, 0.12);
  border-color: rgba(255, 210, 0, 0.3);
  color: var(--yellow-ink);
}
.status-badge--active i {
  animation: pulse 2s ease-in-out infinite;
  font-size: 0.6rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.social-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  border-radius: 0.7rem;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.6);
  color: var(--ink);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}
.social-link:hover {
  background: rgba(255, 210, 0, 0.12);
  border-color: rgba(255, 210, 0, 0.4);
  color: var(--yellow);
  transform: translateY(-2px);
}
.social-link:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}
.social-link i {
  font-size: 1.1rem;
}
@media (max-width: 640px) {
  .social-link span {
    display: none;
  }
}

.timeline {
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
}

.timeline-item {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: 0 4px 16px var(--shadow);
}
.timeline-item:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}

.timeline-top {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap;
}

.timeline-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--yellow-ink);
}

.timeline-degree {
  margin: 0.5rem 0 0 0;
  color: var(--ink);
  font-size: 1rem;
  font-weight: 600;
}

.timeline-meta {
  color: var(--muted);
  font-size: 0.95rem;
}

.timeline-bullets {
  margin: 0.85rem 0 0 1.1rem;
  color: var(--ink);
}
.timeline-bullets li {
  margin: 0.35rem 0;
}
.timeline-bullets li strong {
  color: var(--muted);
  font-weight: 650;
}

.timeline-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 0.25rem;
  background: transparent;
  border-radius: 0.75rem;
  border: 0;
}

.edu-logo {
  max-width: 120px;
  height: 80px;
  -o-object-fit: contain;
     object-fit: contain;
  border: 0;
  background: transparent;
  box-shadow: none;
  filter: none;
  transition: transform 0.2s ease;
}
.timeline-item:hover .edu-logo, .edu-item:hover .edu-logo {
  transform: scale(1.05);
}

.timeline--grid {
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
}
@media (max-width: 900px) {
  .timeline--grid {
    grid-template-columns: 1fr;
  }
}

.experience-logo {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.75rem;
  padding: 0.25rem;
  background: transparent;
  border-radius: 0.5rem;
  border: 0;
  width: -moz-fit-content;
  width: fit-content;
}

.company-logo {
  max-width: 100px;
  height: 50px;
  -o-object-fit: contain;
     object-fit: contain;
  border: 0;
  background: transparent;
  box-shadow: none;
  filter: none;
  transition: transform 0.2s ease;
}
.timeline-main:hover .company-logo {
  transform: scale(1.05);
}

.about-content {
  max-width: 70ch;
  margin: 0 auto;
}
.about-content p {
  font-size: 1.05rem;
  line-height: 1.75;
  margin: 0 0 1.25rem 0;
  color: var(--ink);
}
.about-content p:last-child {
  margin-bottom: 0;
}

.timeline--split {
  --timeline-line: rgba(255, 210, 0, 0.22);
  --timeline-dot: var(--yellow);
  --timeline-dot-ring: rgba(255, 210, 0, 0.14);
  --meta-col: 12.5rem;
  --axis-x: calc(var(--meta-col) + 1.25rem);
  position: relative;
  gap: 1.25rem;
}
.timeline--split::before {
  content: "";
  position: absolute;
  top: 0.5rem;
  bottom: 0.5rem;
  left: var(--axis-x);
  width: 2px;
  border-radius: 2px;
  background: linear-gradient(to bottom, transparent, var(--timeline-line) 10%, var(--timeline-line) 90%, transparent);
}
.timeline--split .timeline-item {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  display: grid;
  grid-template-columns: var(--meta-col) 1fr;
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
  align-items: start;
  position: relative;
}
.timeline--split .timeline-item::before, .timeline--split .timeline-item::after {
  content: "";
  position: absolute;
  top: 1.1rem;
  left: var(--axis-x);
  transform: translateX(-50%);
  border-radius: 999px;
  pointer-events: none;
}
.timeline--split .timeline-item::before {
  width: 10px;
  height: 10px;
  background: var(--timeline-dot);
  box-shadow: 0 0 0 1px rgba(17, 17, 17, 0.22);
  z-index: 2;
}
.timeline--split .timeline-item::after {
  width: 30px;
  height: 30px;
  transform: translate(-50%, -10px);
  background: radial-gradient(circle at center, var(--timeline-dot-ring), transparent 70%);
  z-index: 1;
}
.timeline--split .timeline-side {
  padding-top: 0.25rem;
  color: var(--muted);
  font-size: 0.95rem;
  line-height: 1.35;
}
.timeline--split .timeline-date {
  font-weight: 650;
  color: var(--ink);
  letter-spacing: -0.01em;
}
.timeline--split .timeline-loc {
  margin-top: 0.25rem;
}
.timeline--split .timeline-main {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: 0 4px 16px var(--shadow);
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.55s ease, transform 0.55s ease;
}
.timeline--split .timeline-main:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}
.timeline--split .timeline-main.is-visible {
  opacity: 1;
  transform: none;
}
.timeline--split .timeline-role {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
}
.timeline--split .timeline-org {
  margin-top: 0.25rem;
  color: var(--muted);
  font-size: 0.98rem;
}
@media (prefers-reduced-motion: reduce) {
  .timeline--split .timeline-main {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
@media (max-width: 640px) {
  .timeline--split {
    --meta-col: 0rem;
    --axis-x: 1.1rem;
    padding-left: 2.25rem;
  }
  .timeline--split::before {
    left: var(--axis-x);
  }
  .timeline--split .timeline-item {
    grid-template-columns: 1fr;
    row-gap: 0.6rem;
  }
  .timeline--split .timeline-side {
    color: var(--muted);
  }
  .timeline--split .timeline-date {
    color: var(--ink);
  }
}

.projects-grid {
  display: grid;
  gap: 1.25rem;
  margin-top: 1.75rem;
  grid-template-columns: repeat(3, 1fr);
}
.projects-grid .project-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow: hidden;
}
.projects-grid .project-card:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}
@media (max-width: 1100px) {
  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 900px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
}

.project-image {
  width: 100%;
  height: 200px;
  background: rgba(255, 210, 0, 0.05);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}
.project-image::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.28), transparent 55%);
  pointer-events: none;
}

.projects-grid .project-kicker {
  display: inline-flex;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 1.25rem;
  background: rgba(255, 210, 0, 0.12);
  border: 1px solid rgba(255, 210, 0, 0.22);
  color: var(--yellow-ink);
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-weight: 750;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-left: auto;
  margin-right: auto;
}

.projects-grid .project-subtitle {
  color: var(--muted);
  font-size: 0.98rem;
  margin-bottom: 1rem;
}

.projects-grid .project-tags li {
  background: rgba(var(--surface-rgb), 0.6);
  color: var(--muted);
}

.projects-grid .project-links {
  margin-top: auto;
}

.project-thumbnail {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  transition: transform 0.3s ease, filter 0.3s ease;
}
.project-card:hover .project-thumbnail {
  transform: scale(1.05);
  filter: brightness(1.1);
}

.project-card .project-kicker,
.project-card .project-title,
.project-card .project-subtitle,
.project-card .project-description,
.project-card .project-tags,
.project-card .project-links {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.project-card .project-kicker {
  margin-top: 1.5rem;
}
.project-card .project-links {
  padding-bottom: 1.25rem;
}

.project-tags {
  list-style: none;
  padding: 0;
  margin: 1rem 0 0;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.project-tags li {
  border: 1px solid var(--border);
  background: rgba(255, 210, 0, 0.06);
  color: var(--muted);
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  font-size: 0.85rem;
}

.projects-footer {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}

.skills-compact {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin-top: 1.75rem;
}
@media (max-width: 900px) {
  .skills-compact {
    grid-template-columns: 1fr;
  }
}

.skill-category-inline {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 1.5rem;
  box-shadow: 0 4px 16px var(--shadow);
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  height: 100%;
}
.skill-category-inline:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}
@media (max-width: 640px) {
  .skill-category-inline {
    flex-direction: column;
    gap: 1rem;
  }
}

.skill-icon {
  flex-shrink: 0;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 210, 0, 0.15), rgba(255, 210, 0, 0.05));
  border: 2px solid rgba(255, 210, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.skill-icon i {
  font-size: 1.5rem;
  color: var(--yellow);
}

.skill-content {
  flex: 1;
  min-width: 0;
}
.skill-content h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--ink);
}

.skill-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  align-content: flex-start;
  min-width: 0;
}

.skill-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.5rem 0.9rem;
  background: rgba(var(--surface-rgb), 0.6);
  border: 1px solid var(--border);
  border-radius: 999px;
  color: var(--ink);
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s ease;
}
.skill-tag i {
  font-size: 1rem;
  color: var(--yellow);
}
.skill-tag:hover {
  background: rgba(255, 210, 0, 0.1);
  border-color: rgba(255, 210, 0, 0.3);
  transform: translateY(-2px);
}

.carousel-container {
  position: relative;
  margin-top: 3rem;
  max-width: 800px;
  margin: 3rem auto 0;
}

.carousel-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  box-shadow: 0 4px 20px var(--shadow);
}
.carousel-wrapper:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.carousel-slide {
  min-width: 100%;
  flex-shrink: 0;
  padding: 3rem 2rem;
  display: none;
  position: relative;
  background-image: radial-gradient(900px 300px at 30% 0%, rgba(255, 210, 0, 0.05), transparent 55%), radial-gradient(900px 300px at 90% 100%, rgba(193, 18, 31, 0.04), transparent 55%);
  background-size: auto;
  background-position: center;
}
.carousel-slide.active {
  display: block;
}
.carousel-slide::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(var(--surface-rgb), 0.25);
  z-index: 1;
}
.carousel-slide .project-card {
  position: relative;
  z-index: 2;
}

.project-card {
  margin: 0;
}

.project-kicker {
  display: inline-block;
  background: var(--yellow);
  color: #111;
  padding: 0.45rem 0.9rem;
  border-radius: 2rem;
  font-weight: 700;
  font-size: 0.8rem;
  margin-bottom: 1.25rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.project-title {
  color: var(--yellow-ink);
  font-size: 1.45rem;
  font-weight: 750;
  margin: 0 0 0.65rem 0;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.project-subtitle {
  color: var(--muted);
  font-size: 1.05rem;
  margin: 0 auto 1.5rem;
  max-width: 58ch;
}

.project-description {
  color: var(--ink);
  line-height: 1.7;
  font-size: 1rem;
  margin: 0 auto 1.75rem;
  max-width: 70ch;
  text-align: left;
}

.projects-grid .project-description {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.project-links {
  display: flex;
  justify-content: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: auto;
  padding-top: 1.1rem;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(var(--surface-rgb), 0.9);
  border: 1px solid var(--border);
  color: var(--ink);
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: bold;
  transition: all 0.3s ease;
  z-index: 10;
}
.carousel-btn:hover {
  background: var(--yellow);
  color: #111;
  border-color: var(--yellow);
  transform: translateY(-50%) scale(1.1);
}
.carousel-btn:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}
.carousel-btn--prev {
  left: -1.5rem;
}
.carousel-btn--next {
  right: -1.5rem;
}
@media (max-width: 900px) {
  .carousel-btn {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.2rem;
  }
  .carousel-btn--prev {
    left: -1.25rem;
  }
  .carousel-btn--next {
    right: -1.25rem;
  }
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 2rem;
}

.carousel-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid var(--muted);
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}
.carousel-indicator:hover {
  border-color: var(--yellow);
  background: rgba(255, 210, 0, 0.3);
}
.carousel-indicator.active {
  background: var(--yellow);
  border-color: var(--yellow);
}
.carousel-indicator:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}

.site-footer {
  padding: 2rem 0;
  color: var(--muted);
  text-align: center;
  background: var(--surface);
  border-top: 1px solid var(--border);
}
.site-footer .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.site-footer small {
  order: 2;
}

.footer-social {
  display: flex;
  justify-content: center;
  gap: 1rem;
  order: 1;
}
.footer-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--ink);
  text-decoration: none;
  font-size: 1.1rem;
  transition: all 0.2s ease;
}
.footer-social a:hover {
  background: rgba(255, 210, 0, 0.12);
  border-color: rgba(255, 210, 0, 0.4);
  color: var(--yellow);
  transform: translateY(-2px);
}
.footer-social a:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}

.contact-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}
.contact-content h2 {
  color: var(--yellow-ink);
  font-size: clamp(1.8rem, 3.5vw, 2.5rem);
  margin: 0 0 1.5rem 0;
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.3;
}
.contact-content .contact-intro {
  font-size: 1.05rem;
  line-height: 1.65;
  margin: 0 0 2.5rem 0;
  color: var(--ink);
}

.contact-card-unified {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  padding: 2rem;
  box-shadow: 0 8px 32px var(--shadow);
  text-align: left;
}
.contact-card-unified:hover {
  border-color: rgba(255, 210, 0, 0.28);
  box-shadow: 0 6px 18px var(--shadow);
  transform: translateY(-1px);
}

.contact-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem 2rem;
  margin-bottom: 2rem;
}
@media (max-width: 640px) {
  .contact-info-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
}

.contact-info-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.contact-info-item i {
  font-size: 1.4rem;
  color: var(--yellow);
  margin-top: 0.2rem;
  flex-shrink: 0;
}
.contact-info-item h3 {
  margin: 0 0 0.35rem 0;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.contact-info-item a, .contact-info-item p {
  margin: 0;
  color: var(--ink);
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}
.contact-info-item a:hover, .contact-info-item p:hover {
  color: var(--yellow);
}
.contact-info-item p {
  color: var(--ink);
}

.contact-inline {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.contact-email-copy {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ink);
  cursor: pointer;
  font: inherit;
  font-size: 1rem;
  font-weight: 650;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  text-decoration-color: rgba(255, 210, 0, 0.4);
  transition: color 0.2s ease, text-decoration-color 0.2s ease, transform 0.06s ease;
}
.contact-email-copy:hover {
  color: var(--yellow);
  text-decoration-color: rgba(255, 210, 0, 0.9);
}
.contact-email-copy:active {
  transform: translateY(1px);
}
.contact-email-copy:focus-visible {
  outline: 2px solid var(--yellow);
  outline-offset: 2px;
}

.toast {
  position: fixed;
  left: 50%;
  bottom: 1.25rem;
  transform: translateX(-50%) translateY(10px);
  z-index: 10050;
  padding: 0.75rem 1rem;
  border-radius: 0.9rem;
  border: 1px solid var(--border);
  background: rgba(var(--surface-rgb), 0.92);
  backdrop-filter: saturate(120%) blur(10px);
  color: var(--ink);
  font-weight: 650;
  box-shadow: 0 10px 35px var(--shadow);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.toast.is-visible {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
@media (max-width: 640px) {
  .toast {
    width: min(520px, calc(100% - 2rem));
    text-align: center;
  }
}

.contact-methods,
.contact-method,
.contact-icon-links,
.contact-icon-link,
.contact-card {
  display: none;
}`, "",{"version":3,"sources":["webpack://./css/main.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qFAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAAA;EAGA,qCAAA;EACA,sCAAA;EACA,sCAAA;AAFF;;AAIA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EAGA,sCAAA;EACA,sCAAA;EACA,sCAAA;AAHF;;AA6CA;EAAyB,sBAAA;AAzCzB;;AA0CA;EAAO,uBAAA;EAAyB,kBAAA;AArChC;;AAsCA;EAAuB,mBAAA;AAlCvB;;AAmCA;EACE,SAAA;EACA,gHAAA;EACA,eAnCU;EAoCV,gBAnCY;EAoCZ,iBA3CI;EA4CJ,kBAAA;EACA,4EACE;EACF,4BAAA;EACA,kCAAA;EACA,aAAA;EACA,iBAAA;AAjCF;;AAmCA;EACE,0EACE;EACF,4BAAA;AAjCF;;AAqCA;;EAEE,WAAA;EACA,eAAA;EACA,QAAA;EACA,oBAAA;EACA,WAAA;AAlCF;;AAsCA;EACE,aAAA;EACA,8WACE;EAIF,4BAAA;EACA,wBAAA;EACA,sDAAA;AAvCF;;AAyCA;EACE,UAAA;EACA,oQACE;AAvCJ;;AA4CA;EACE,YAAA;EACA,mBAAA;EACA,qZACE;AA1CJ;;AA+CA;EACE,kTACE;EAGF,aAAA;EACA,mBAAA;AA/CF;;AAiDA;EAAa,uBAAA;EAA2B,cAAA;AA5CxC;;AA6CA;EAAI,cAAA;AAzCJ;;AA4CA;EACE,OAAA;EACA,kBAAA;EACA,yBAAA;AAzCF;AAzDuB;EA+FvB;IAMI,cAAA;IACA,WAAA;EAxCF;AACF;;AA4CA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,+BAAA;AAzCF;AA9EuB;EA2GvB;IAeI,4BAAA;EAxCF;EA0CE;IACE,wBAAA;EAxCJ;AACF;;AA4CA;EACE,yBAAA;EACA,sCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzCF;;AA4CA;EACE,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAzCF;AA2CE;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;KAAA,iBAAA;EACA,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,yCAAA;AAzCJ;AA4CE;EACE,gBAAA;EACA,uBAAA;EACA,iBA5KE;EA6KF,eAAA;EACA,cAAA;AA1CJ;AA6CE;EAAsB,wBAnLZ;AAyIZ;;AA1HkB;EAwKhB;IAA6B,aAAA;EAzC7B;AACF;AA2CA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAlMI;EAmMJ,eAAA;EACA,iBAAA;EACA,iDAAA;AAzCF;AA2CE;EACE,mCAAA;EACA,wBA3MQ;AAkKZ;AA4CE;EACE,gCAAA;EACA,mBAAA;AA1CJ;AA6CE;EAA0B,aAAA;AA1C5B;AA2CE;EAA2B,eAAA;AAxC7B;;AA2CA;EAAsE,eAAA;AAvCtE;;AAwCA;EAAuE,aAAA;AApCvE;;AAsCA;EACE,OAAA;EACA,iBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAnCF;;AAsCA;EACE,cAAA;EACA,qBAAA;EACA,iBAvOI;EAwOJ,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yEAAA;EACA,kCAAA;AAnCF;AAqCE;EACE,mCAAA;EACA,wBAlPQ;EAmPR,qBAAA;AAnCJ;AAsCE;EACE,mCAAA;EACA,wBAxPQ;EAyPR,oCAzPQ;EA0PR,qBAAA;AApCJ;;AAyCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,mCAAA;EACA,gBAAA;EAAkB,6DAAA;AArCpB;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBA1QI;EA2QJ,iBAAA;EACA,kBAAA;EACA,yBAAA;AArCJ;AAuCI;EACE,wBAnRM;EAoRN,kCAAA;AArCN;;AA0CA;EACE,2BAAA;EACA,kBAAA;AAvCF;AAyCE;EACE,cAAA;EACA,mBA5RI;EA6RJ,iBAAA;EACA,gBAAA;EACA,YAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,0CAAA;EACA,0CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAxCF;AA0CE;EACE,uCAAA;AAxCJ;AA2CE;EACE,gCAAA;EACA,mBAAA;AAzCJ;AA4CE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,sBA/TE;EAgUF,kDAAA;AA1CJ;AA4CI;EACE,eAAA;AA1CN;AA+CI;EAAoB,wCAAA;AA5CxB;AA6CI;EAAoB,UAAA;AA1CxB;AA2CI;EAAoB,0CAAA;AAxCxB;AApRuB;EAsRvB;IA0CI,cAAA;EAxCF;AACF;;AA4CA;EACE,aAAA;AAzCF;;AA6CA;EACE,mCAAA;AA1CF;AA4CE;EACE,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,kBAAA;EAAoB,kBAAA;EAC1E,yLACE;EAEF,qBAAA;EACA,2BAAA;AAxCJ;AArSE;EAAY,WAAA;EAAa,kBAAA;EAAoB,QAAA;EAAU,yCAAA;EAAmD,UAAA;AA4S5G;AAmCI;EAAa,kBAAA;EAAoB,UAAA;AA/BrC;AAgCI;EACE,kBAAA;EACA,wBAxWM;EAyWN,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AA9BN;AAgCI;EACE,mCAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;AA9BN;AAgCI;EACE,iBApXA;EAqXA,sCAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AA9BN;AAgCI;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AA9BN;AAgCI;EAAgB,aAAA;EAAe,YAAA;EAAa,uBAAA;EAAyB,eAAA;EAAiB,mBAAA;AAzB1F;AA0BI;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAxBN;AA0BI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;EACA,yCAAA;EACA,+BAAA;EACA,iBAlZA;EAmZA,iBAAA;EACA,gBAAA;AAxBN;AA0BM;EAAI,wBAxZE;EAwZiB,kBAAA;AAtB7B;AAwBI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAtBN;AA0BE;EACE,yCAAA;AAxBJ;AA2BE;EACE,kBAAA;EACA,wLACE;AA1BN;AA1XE;EAAY,WAAA;EAAa,kBAAA;EAAoB,QAAA;EAAU,yCAAA;EAAmD,UAAA;AAiY5G;AAsBI;EAAa,kBAAA;EAAoB,UAAA;AAlBrC;;AAuBA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;EACA,kBAAA;AApBF;AAlZuB;EAkavB;IAOI,0BAAA;EAnBF;AACF;;AAsBA;EApaE,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAmaA,6BAAA;EACA,oCAAA;EACA,aAAA;EACA,iCAAA;EACA,SAAA;EACA,kBAAA;AAhBF;AAvZE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AA4ZnF;AA1akB;EA8alB;IAUI,0BAAA;IACA,gBAAA;EAVF;AACF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAVF;;AAaA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAheU;AAsdZ;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0CAAA;EACA,mBAveM;EAweN,iBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;EACE,iBAxfI;EAyfJ,eAAA;EACA,gBAAA;AAVF;;AAaA;EACE,mBA7fM;EA8fN,kBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,0BAAA;EACA,iBArgBI;AA2fN;AAYE;EACE,iBAAA;AAVJ;AAYI;EACE,mBA1gBE;EA2gBF,gBAAA;AAVN;;AAeA;EACE,eAAA;EACA,iBAnhBI;EAohBJ,gBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAZF;;AAeA;EACE,+BAAA;EACA,qBAAA;EACA,eAAA;EACA,0CAAA;AAZF;;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,mBAtiBM;EAuiBN,sBAAA;EACA,yBAAA;EACA,sBAAA;AAZF;;AAeA;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AAZF;;AAeA;EACE,gDAAA;AAZF;AA9hBkB;EAyiBlB;IAII,0BAAA;EAXF;AACF;;AAcA;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;AAXF;;AAcA;EACE,+GAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAzkBI;EA0kBJ,mBAAA;AAXF;;AAcA;EACE,iBA9kBI;EA+kBJ,gBAAA;EACA,gBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;EACA,kCAAA;EACA,wBA9lBU;EA+lBV,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,iBAnmBI;EAomBJ,gBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;EACA,0CAAA;EACA,mBA9mBM;EA+mBN,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,iBAvnBI;EAwnBJ,gBAAA;AAXF;;AAcA;EACE,mBA3nBM;EA4nBN,gBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAeA;EACE,gBAAA;AAZF;;AAeA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;AAZF;;AAeA;EACE,kBAAA;EACA,QAAA;EACA,+BAAA;AAZF;;AAeA;EACE,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,0CAAA;EACA,0CAAA;EACA,qCAAA;EACA,gBAAA;EACA,UAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;EACA,sCAAA;AAZF;;AAeA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBA3rBI;AA+qBN;;AAeA;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,+BAAA;EACA,0CAAA;EACA,mBAjsBM;EAksBN,aAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,+FAAA;AAZF;AAcE;EACE,mCAAA;EACA,qCAAA;EACA,wBAjtBQ;AAqsBZ;AAeE;EAAW,0BAAA;AAZb;AAaE;EAAkB,gCAAA;EAA4B,mBAAA;AAThD;;AAYA;EACE,aAAA;EACA,cAAA;AATF;;AAcE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;AAXJ;;AAgBA;EAAkB,kBAAA;AAZlB;;AAaA;EACE,oBAAA;EACA,qCAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAVF;AAYE;EACE,aAAA;EACA,wBAjvBQ;EAkvBR,gBAAA;AAVJ;;AAaA;EAAoB,SAAA;EAAW,mBAlvBvB;EAkvBsC,eAAA;EAAiB,kBAAA;AAN/D;;AASA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAC3C,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,0BA1vBQ;EA2vBR,iBA9vBI;EA+vBJ,gBAAA;EACA,eAAA;EACA,qHAAA;AAJF;AA/tBE;EAAU,yBAjCH;EAiCwB,WAAA;EAAa,2BAjCrC;AAqwBT;AAnuBE;EAAkB,gCAAA;EAA4B,mBAAA;AAuuBhD;AAHE;EAAW,0BAAA;AAMb;AAJE;EACE,yBAzwBK;EA0wBL,2BA1wBK;EA2wBL,WAAA;AAMJ;AALI;EAAU,+BAAA;EAAiC,iCAAA;AAS/C;AANE;EACE,uBAAA;AAQJ;AAPI;EAAU,mCAAA;EAAqC,qCAAA;EAAuC,wBAhxB9E;AA4xBZ;AATE;EACE,uBAAA;EACA,qBAAA;EACA,iBAAA;AAWJ;;AANA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,yCAAA;EACA,+BAAA;EACA,mBAhyBM;EAiyBN,iBAAA;EACA,gBAAA;AASF;AAPE;EACE,mCAAA;EACA,oCAAA;EACA,wBA1yBQ;AAmzBZ;AAPI;EACE,wCAAA;EACA,iBAAA;AASN;;AAJA;EACE;IAAW,UAAA;EAQX;EAPA;IAAM,YAAA;EAUN;AACF;AAPA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,+BAAA;EACA,yCAAA;EACA,iBA/zBI;EAg0BJ,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+FAAA;AASF;AAPE;EACE,mCAAA;EACA,oCAAA;EACA,oBA30BK;EA40BL,2BAAA;AASJ;AANE;EACE,gCAAA;EACA,mBAAA;AAQJ;AALE;EACE,iBAAA;AAOJ;AA50BkB;EAw0BhB;IAEI,aAAA;EAMJ;AACF;;AADA;EAAY,aAAA;EAAe,SAAA;EAAW,kBAAA;AAOtC;;AANA;EAv0BE,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAo0BmC,6BAAA;EAA+B,oCAAA;AAepE;AAl1BE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AAu1BnF;;AAnBA;EAAgB,aAAA;EAAe,8BAAA;EAAgC,qBAAA;EAAuB,SAAA;EAAW,eAAA;AA2BjG;;AA1BA;EAAkB,SAAA;EAAW,iBAAA;EAAmB,gBAAA;EAAkB,wBAl2BtD;AAm4BZ;;AAhCA;EACE,oBAAA;EACA,iBAn2BI;EAo2BJ,eAAA;EACA,gBAAA;AAmCF;;AAjCA;EAAiB,mBAt2BT;EAs2BwB,kBAAA;AAsChC;;AArCA;EACE,0BAAA;EACA,iBA12BI;AAk5BN;AAvCE;EACE,iBAAA;AAyCJ;AAxCI;EACE,mBA72BE;EA82BF,gBAAA;AA0CN;;AApCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAuCF;;AApCA;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;AAuCF;AArCE;EAEE,sBAAA;AAsCJ;;AAjCA;EACE,qCAAA;EACA,YAAA;AAoCF;AAx6BuB;EAk4BvB;IAKI,0BAAA;EAqCF;AACF;;AAjCA;EACE,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,uBAAA;EAAA,kBAAA;AAoCF;;AAjCA;EACE,gBAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;AAoCF;AAlCE;EACE,sBAAA;AAoCJ;;AA/BA;EACE,eAAA;EACA,cAAA;AAkCF;AAhCE;EACE,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBA77BE;AA+9BN;AAhCI;EACE,gBAAA;AAkCN;;AA5BA;EACE,wCAAA;EACA,6BAAA;EACA,4CAAA;EACA,mBAAA;EACA,yCAAA;EAEA,kBAAA;EACA,YAAA;AA8BF;AA5BE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,oHAAA;AA8BJ;AA3BE;EAEE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EAEA,aAAA;EACA,0CAAA;EACA,uBAAA;OAAA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA2BJ;AAzBI;EAEE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;AA0BN;AAvBI;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,4CAAA;EACA,UAAA;AAyBN;AAtBI;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,wFAAA;EACA,UAAA;AAwBN;AApBE;EACE,oBAAA;EACA,mBAtgCI;EAugCJ,kBAAA;EACA,iBAAA;AAsBJ;AApBE;EAAiB,gBAAA;EAAkB,iBA3gC/B;EA2gC4C,uBAAA;AAyBlD;AAxBE;EAAgB,mBAAA;AA2BlB;AAzBE;EAv/BA,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAs/BE,6BAAA;EACA,oCAAA;EAGA,UAAA;EACA,2BAAA;EACA,oDAAA;AA4BJ;AAvhCE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AA4hCnF;AA/BI;EACE,UAAA;EACA,eAAA;AAiCN;AA7BE;EAAiB,SAAA;EAAW,iBAAA;EAAmB,gBAAA;AAkCjD;AAjCE;EAAgB,mBAAA;EAAoB,mBA9hC9B;EA8hC6C,kBAAA;AAsCrD;AApCE;EACE;IAAiB,UAAA;IAAY,eAAA;IAAiB,gBAAA;EAyChD;AACF;AA/jCkB;EAy7BlB;IAgGI,gBAAA;IACA,gBAAA;IAEA,qBAAA;EAyCF;EAvCE;IAAY,mBAAA;EA0Cd;EAxCE;IACE,0BAAA;IACA,eAAA;EA0CJ;EAvCE;IAAiB,mBAjjCb;EA2lCN;EAzCE;IAAiB,iBAnjCf;EA+lCJ;AACF;;AAxCA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;AA2CF;AAzCE;EAviCA,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAsiCE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AA8CJ;AAxlCE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AA6lCnF;AAhDE;EAhBF;IAiBI,qCAAA;EAmDF;AACF;AA/mCuB;EA0iCvB;IAqBI,0BAAA;EAoDF;AACF;;AAhDA;EACE,WAAA;EACA,aAAA;EACA,mCAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAmDF;AAjDE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yEAAA;EACA,oBAAA;AAmDJ;;AA/CA;EACE,oBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,yCAAA;EACA,wBA9mCU;EA+mCV,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AAkDF;;AA/CA;EACE,mBAvnCM;EAwnCN,kBAAA;EACA,mBAAA;AAkDF;;AA/CA;EACE,yCAAA;EACA,mBA9nCM;AAgrCR;;AA/CA;EACE,gBAAA;AAkDF;;AA/CA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;KAAA,iBAAA;EACA,iDAAA;AAkDF;AAhDE;EACE,sBAAA;EACA,uBAAA;AAkDJ;;AA5CE;;;;;;EAME,oBAAA;EACA,qBAAA;AA+CJ;AA5CE;EACE,kBAAA;AA8CJ;AA3CE;EACE,uBAAA;AA6CJ;;AAzCA;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AA4CF;AA1CE;EACE,+BAAA;EACA,mCAAA;EACA,mBAjrCI;EAkrCJ,wBAAA;EACA,oBAAA;EACA,kBAAA;AA4CJ;;AAxCA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AA2CF;;AAvCA;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,mBAAA;AA0CF;AAhuCuB;EAkrCvB;IAOI,0BAAA;EA2CF;AACF;;AAxCA;EAprCE,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAmrCA,eAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AA8CF;AAruCE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AA0uCnF;AAxvCkB;EA8rClB;IAUI,sBAAA;IACA,SAAA;EAoDF;AACF;;AAjDA;EACE,cAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qFAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAoDF;AAlDE;EACE,iBAAA;EACA,oBA1uCK;AA8xCT;;AAhDA;EACE,OAAA;EACA,YAAA;AAmDF;AAjDE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAnvCE;AAsyCN;;AA/CA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AAkDF;;AA/CA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,yCAAA;EACA,+BAAA;EACA,oBAAA;EACA,iBAvwCI;EAwwCJ,iBAAA;EACA,gBAAA;EACA,yBAAA;AAkDF;AAhDE;EACE,eAAA;EACA,oBAjxCK;AAm0CT;AA/CE;EACE,kCAAA;EACA,oCAAA;EACA,2BAAA;AAiDJ;;AA5CA;EAAsB,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;AAmD9E;;AAlDA;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;EAnwCxD,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAgwCiG,oCAAA;AA6DnG;AA5zCE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AAi0CnF;;AAjEA;EAAkB,aAAA;EAAe,sCAAA;AAsEjC;;AArEA;EACE,eAAA;EAAiB,cAAA;EAAgB,kBAAA;EAAoB,aAAA;EAAe,kBAAA;EACpE,sLACE;EAEF,qBAAA;EACA,2BAAA;AA0EF;AAzEE;EAAW,cAAA;AA4Eb;AA31CE;EAAY,WAAA;EAAa,kBAAA;EAAoB,QAAA;EAAU,0CAAA;EAAmD,UAAA;AAk2C5G;AAjFE;EAAgB,kBAAA;EAAoB,UAAA;AAqFtC;;AAlFA;EAAgB,SAAA;AAsFhB;;AArFA;EAAkB,qBAAA;EAAuB,yBA5yChC;EA4yCqD,WAAA;EAAa,uBAAA;EAAyB,mBAAA;EAAqB,gBAAA;EAAkB,iBAAA;EAAmB,sBAAA;EAAwB,yBAAA;EAA2B,qBAAA;AAkGjN;;AAjGA;EAAiB,wBA5yCL;EA4yCwB,kBAAA;EAAoB,gBAAA;EAAkB,qBAAA;EAAsB,iBAAA;EAAmB,uBAAA;AA0GnH;;AAzGA;EAAoB,mBA1yCZ;EA0yC2B,kBAAA;EAAoB,qBAAA;EAAuB,eAAA;AAgH9E;;AA/GA;EAAuB,iBA5yCjB;EA4yC8B,gBAAA;EAAkB,eAAA;EAAiB,sBAAA;EAAwB,eAAA;EAAiB,gBAAA;AAwHhH;;AAvHA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA0HF;;AAxHA;EAAiB,aAAA;EAAe,2BAAA;EAA6B,YAAA;EAAa,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;AAiI7G;;AA/HA;EACE,kBAAA;EAAoB,QAAA;EAAU,2BAAA;EApyCX,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAqyCvD,yCAAA;EAA2C,+BAAA;EAA2B,iBAvzClE;EAwzCJ,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,eAAA;EAAiB,iBAAA;EAAmB,iBAAA;EACnF,yBAAA;EAA2B,WAAA;AA+I7B;AA9IE;EAAU,yBA7zCH;EA6zCwB,WAAA;EAAa,2BA7zCrC;EA6zC4D,sCAAA;AAoJrE;AAnJE;EAAkB,gCAAA;EAA4B,mBAAA;AAuJhD;AAtJE;EAAU,aAAA;AAyJZ;AAxJE;EAAU,cAAA;AA2JZ;AA18CuB;EAuyCvB;IAUI,aAAA;IAAe,cAAA;IAAgB,iBAAA;EA+JjC;EA9JE;IAAU,cAAA;EAiKZ;EAhKE;IAAU,eAAA;EAmKZ;AACF;;AAhKA;EAAuB,aAAA;EAAe,uBAAA;EAAyB,WAAA;EAAa,gBAAA;AAuK5E;;AAtKA;EACE,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,8BAAA;EAA0B,uBAAA;EAAyB,eAAA;EAAiB,yBAAA;AA+KrH;AA9KE;EAAU,2BA30CH;EA20C0B,kCAAA;AAkLnC;AAjLE;EAAW,yBA50CJ;EA40CyB,2BA50CzB;AAigDT;AApLE;EAAkB,gCAAA;EAA4B,mBAAA;AAwLhD;;AApLA;EACE,eAAA;EACA,mBA/0CM;EAg1CN,kBAAA;EACA,0BA/0CQ;EAg1CR,mCAAA;AAuLF;AArLE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAuLJ;AApLE;EACE,QAAA;AAsLJ;;AAjLA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,QAAA;AAoLF;AAlLE;EAt1CmB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAw1CrD,cAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iBA/2CE;EAg3CF,qBAAA;EACA,iBAAA;EACA,yBAAA;AAsLJ;AApLI;EACE,mCAAA;EACA,oCAAA;EACA,oBA13CG;EA23CH,2BAAA;AAsLN;AAnLI;EACE,gCAAA;EACA,mBAAA;AAqLN;;AAjLA;EACE,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;AAsLxC;AArLE;EACE,wBAt4CQ;EAu4CR,uCAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAuLJ;AArLE;EAAiB,kBAAA;EAAoB,iBAAA;EAAmB,oBAAA;EAAsB,iBA34C1E;AAskDN;;AAvLA;EAx3CE,0BApBQ;EAqBR,+BAAA;EACA,4BAAA;EACA,mGAAA;EAu3CA,aAAA;EACA,oCAAA;EACA,gBAAA;AA6LF;AArjDE;EAAU,qCAAA;EAAuC,oCAAA;EAAgC,2BAAA;AA0jDnF;;AA/LA;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;AAkMF;AA/kDkB;EAy4ClB;IAOI,0BAAA;IACA,YAAA;EAmMF;AACF;;AAhMA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAmMF;AAjME;EACE,iBAAA;EACA,oBA56CK;EA66CL,kBAAA;EACA,cAAA;AAmMJ;AAhME;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAj7CI;EAk7CJ,yBAAA;EACA,sBAAA;AAkMJ;AA/LE;EACE,SAAA;EACA,iBAz7CE;EA07CF,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;AAiMJ;AA/LI;EACE,oBAn8CG;AAooDT;AA7LE;EACE,iBAr8CE;AAooDN;;AA3LA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA8LF;;AA3LA;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAx9CI;EAy9CJ,eAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,kFAAA;AA8LF;AA5LE;EACE,oBAv+CK;EAw+CL,6CAAA;AA8LJ;AA3LE;EAAW,0BAAA;AA8Lb;AA7LE;EAAkB,gCAAA;EAA4B,mBAAA;AAiMhD;;AA7LA;EACE,eAAA;EACA,SAAA;EACA,eAAA;EACA,4CAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,+BAAA;EACA,0CAAA;EACA,0CAAA;EACA,iBAx/CI;EAy/CJ,gBAAA;EACA,qCAAA;EACA,UAAA;EACA,oBAAA;EACA,oDAAA;AAgMF;AA9LE;EACE,UAAA;EACA,yCAAA;AAgMJ;AAprDkB;EAg+ClB;IAwBI,oCAAA;IACA,kBAAA;EAgMF;AACF;;AA5LA;;;;;EAKE,aAAA;AA+LF","sourcesContent":["// Theme: CSS custom properties (enables light/dark toggle)\n:root {\n  --bg: #0a0e27;\n  --surface: #0f1428;\n  --ink: #f5f7fb;\n  --muted: #a7b0c0;\n  --border: #1e2139;\n  --yellow: #ffd200;\n  /* Accent color for text/icons. In light mode, pure yellow on white fails contrast. */\n  --yellow-ink: #ffd200;\n  --yellow-hover: #ffe033;\n  --red: #c1121f;\n  --shadow: rgba(0, 0, 0, 0.35);\n  --surface-rgb: 15, 20, 40;\n  --radius: 1rem;\n  \n  // Gradient colors\n  --gradient-1: rgba(99, 102, 241, 0.1);\n  --gradient-2: rgba(168, 85, 247, 0.08);\n  --gradient-3: rgba(236, 72, 153, 0.06);\n}\n[data-theme=\"light\"] {\n  --bg: #f8fafc;\n  --surface: #ffffff;\n  --ink: #1a1d24;\n  --muted: #5c6370;\n  --border: #e2e6ee;\n  --shadow: rgba(0, 0, 0, 0.08);\n  --surface-rgb: 255, 255, 255;\n  --yellow-ink: #8a5200;\n  --yellow-hover: #e6bd00;\n  \n  // Light theme gradients\n  --gradient-1: rgba(99, 102, 241, 0.05);\n  --gradient-2: rgba(168, 85, 247, 0.04);\n  --gradient-3: rgba(236, 72, 153, 0.03);\n}\n\n// SCSS variables mapped to CSS vars (rest of file unchanged)\n$yellow: var(--yellow);\n$yellowInk: var(--yellow-ink);\n$red: var(--red);\n$ink: var(--ink);\n$muted: var(--muted);\n$bg: var(--bg);\n$surface: var(--surface);\n$border: var(--border);\n$shadow: var(--shadow);\n$font-base: 16px;\n$line-height: 1.6;\n$maxw: 1100px;\n$nav-h: 72px;\n$nav-h-small: 56px; \n\n@mixin respond($bp) {\n  @if $bp == sm { @media (max-width: 640px) { @content; } }\n  @else if $bp == md { @media (max-width: 900px) { @content; } }\n  @else if $bp == lg { @media (max-width: 1200px) { @content; } }\n}\n\n@mixin flex-center { display: flex; align-items: center; justify-content: center; }\n@mixin overlay($opacity: 0.85) {\n  &::before { content: ''; position: absolute; inset: 0; background: rgba(var(--surface-rgb), #{$opacity}); z-index: 1; }\n}\n@mixin card-base {\n  background: $surface;\n  border: 1px solid $border;\n  border-radius: var(--radius);\n  transition: border-color .2s ease, transform .2s ease, box-shadow .2s ease, background .2s ease;\n  &:hover { border-color: rgba(255, 210, 0, 0.28); box-shadow: 0 6px 18px $shadow; transform: translateY(-1px); }\n}\n@mixin btn-hover { \n  &:hover { background: $yellow; color: #111; border-color: $yellow; }\n  &:focus-visible { outline: 2px solid $yellow; outline-offset: 2px; }\n}\n\n//Base styles\n*, *::before, *::after { box-sizing: border-box; }\nhtml { scroll-behavior: smooth; color-scheme: dark; }\n[data-theme=\"light\"] { color-scheme: light; }\nbody {\n  margin: 0;\n  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n  font-size: $font-base;\n  line-height: $line-height;\n  color: $ink;\n  position: relative;\n  background:\n    linear-gradient(135deg, #070a1d 0%, $bg 55%, #0b1233 100%);\n  background-attachment: fixed;\n  text-rendering: optimizeLegibility;\n  display: flex;\n  min-height: 100vh;\n}\n[data-theme=\"light\"] body {\n  background:\n    linear-gradient(180deg, #bfe6ff 0%, #d8f0ff 45%, #f8fafc 100%);\n  background-attachment: fixed;\n}\n\n// Background decoration layers (stars in dark, clouds in light)\nbody::before,\nbody::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: -1;\n}\n\n// Stars (dark mode)\nbody::before {\n  opacity: 0.85;\n  background-image:\n    radial-gradient(1px 1px at 25px 25px, rgba(255,255,255,0.75) 60%, transparent 61%),\n    radial-gradient(1px 1px at 80px 45px, rgba(255,255,255,0.55) 60%, transparent 61%),\n    radial-gradient(1px 1px at 60px 90px, rgba(255,255,255,0.35) 60%, transparent 61%),\n    radial-gradient(2px 2px at 110px 130px, rgba(255,255,255,0.28) 60%, transparent 61%);\n  background-size: 160px 160px;\n  background-position: 0 0;\n  filter: drop-shadow(0 0 2px rgba(255,255,255,0.18));\n}\nbody::after {\n  opacity: 1;\n  background:\n    radial-gradient(900px 500px at 15% 10%, rgba(255, 210, 0, 0.08), transparent 55%),\n    radial-gradient(900px 500px at 85% 20%, rgba(99, 102, 241, 0.10), transparent 60%),\n    radial-gradient(900px 600px at 50% 90%, rgba(236, 72, 153, 0.06), transparent 60%);\n}\n\n[data-theme=\"light\"] body::before {\n  opacity: 0.9;\n  filter: blur(0.2px);\n  background:\n    radial-gradient(220px 140px at 10% 22%, rgba(255,255,255,0.85) 0%, rgba(255,255,255,0) 65%),\n    radial-gradient(300px 180px at 32% 14%, rgba(255,255,255,0.75) 0%, rgba(255,255,255,0) 66%),\n    radial-gradient(280px 170px at 60% 20%, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 68%),\n    radial-gradient(340px 200px at 84% 16%, rgba(255,255,255,0.75) 0%, rgba(255,255,255,0) 66%);\n}\n[data-theme=\"light\"] body::after {\n  background:\n    radial-gradient(380px 240px at 18% 38%, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 70%),\n    radial-gradient(420px 260px at 55% 42%, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 72%),\n    radial-gradient(420px 260px at 86% 46%, rgba(255,255,255,0.45) 0%, rgba(255,255,255,0) 72%);\n  opacity: 0.75;\n  filter: blur(0.6px);\n}\n.container { width: min(#{$maxw}, 92%); margin: 0 auto; }\na { color: inherit; }\n\n// Main content wrapper\n.main-content {\n  flex: 1;\n  margin-left: 200px;\n  width: calc(100% - 200px);\n  \n  @include respond(md) {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n\n// Sidebar Navigation\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 200px;\n  background: rgba(var(--surface-rgb), 0.95);\n  backdrop-filter: saturate(120%) blur(10px);\n  border-right: 1px solid $border;\n  display: flex;\n  flex-direction: column;\n  z-index: 9999;\n  transition: transform 0.3s ease;\n  \n  @include respond(md) {\n    transform: translateX(-100%);\n    \n    &.sidebar-open {\n      transform: translateX(0);\n    }\n  }\n}\n\n.sidebar-header {\n  padding: 1.5rem 1rem 1rem;\n  border-bottom: 1px solid $border;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-brand {\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: .6rem;\n\n  .brand-avatar {\n    width: 2.1rem;\n    height: 2.1rem;\n    border-radius: 999px;\n    object-fit: cover;\n    display: block;\n    border: 1px solid rgba(255, 210, 0, 0.25);\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n    background: rgba(var(--surface-rgb), 0.6);\n  }\n\n  .brand-name {\n    font-weight: 750;\n    letter-spacing: -0.01em;\n    color: $ink;\n    font-size: 1rem;\n    line-height: 1;\n  }\n\n  &:hover .brand-name { color: $yellowInk; }\n}\n\n@include respond(sm) {\n  .sidebar-brand .brand-name { display: none; }\n}\n\n.sidebar .theme-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n  border: 0;\n  border-radius: .5rem;\n  background: transparent;\n  color: $ink;\n  cursor: pointer;\n  font-size: 1.1rem;\n  transition: background .2s ease, color .2s ease;\n  \n  &:hover {\n    background: rgba(255, 210, 0, 0.12);\n    color: $yellowInk;\n  }\n  \n  &:focus-visible {\n    outline: 2px solid $yellow;\n    outline-offset: 2px;\n  }\n  \n  .theme-toggle-icon--sun { display: none; }\n  .theme-toggle-icon--moon { display: inline; }\n}\n\n[data-theme=\"light\"] .sidebar .theme-toggle .theme-toggle-icon--sun { display: inline; }\n[data-theme=\"light\"] .sidebar .theme-toggle .theme-toggle-icon--moon { display: none; }\n\n.sidebar-nav {\n  flex: 1;\n  padding: 1.5rem 0;\n  overflow-y: auto;\n}\n\n.nav-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.75rem 1rem;\n  color: $ink;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.95rem;\n  transition: background .2s ease, color .2s ease, padding-left .2s ease;\n  border-left: 3px solid transparent;\n  \n  &:hover {\n    background: rgba(255, 210, 0, 0.08);\n    color: $yellowInk;\n    padding-left: 1.25rem;\n  }\n  \n  &.is-active {\n    background: rgba(255, 210, 0, 0.12);\n    color: $yellowInk;\n    border-left-color: $yellowInk;\n    padding-left: 1.25rem;\n  }\n}\n\n// Sidebar social icons (restored)\n.sidebar-social {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem 1rem 0.5rem;\n  border-top: 1px solid $border;\n  margin-top: auto; /* Push to bottom if needed, though sidebar-nav has flex: 1 */\n  \n  a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 2rem;\n    height: 2rem;\n    color: $muted;\n    font-size: 1.1rem;\n    border-radius: 50%;\n    transition: all 0.2s ease;\n    \n    &:hover {\n      color: $yellowInk;\n      background: rgba(255, 210, 0, 0.1);\n    }\n  }\n}\n\n.sidebar-footer-text {\n  padding: 0.5rem 1rem 1.5rem;\n  text-align: center;\n  \n  small {\n    display: block;\n    color: $muted;\n    font-size: 0.7rem;\n    line-height: 1.5;\n    opacity: 0.8;\n  }\n}\n\n.sidebar-toggle {\n  display: none;\n  position: fixed;\n  top: 1rem;\n  left: 1rem;\n  z-index: 10000;\n  background: rgba(var(--surface-rgb), 0.95);\n  backdrop-filter: saturate(120%) blur(10px);\n  border: 1px solid $border;\n  border-radius: .5rem;\n  padding: .75rem;\n  cursor: pointer;\n  transition: background .2s ease;\n  \n  &:hover {\n    background: rgba(var(--surface-rgb), 1);\n  }\n  \n  &:focus-visible {\n    outline: 2px solid $yellow;\n    outline-offset: 2px;\n  }\n  \n  .bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    background: $ink;\n    transition: transform .2s ease, opacity .2s ease;\n    \n    & + .bar {\n      margin-top: 5px;\n    }\n  }\n  \n  &[aria-expanded=\"true\"] {\n    .bar:nth-child(1) { transform: translateY(7px) rotate(45deg); }\n    .bar:nth-child(2) { opacity: 0; }\n    .bar:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }\n  }\n  \n  @include respond(md) {\n    display: block;\n  }\n}\n\n// Hide old header\n.site-header {\n  display: none;\n}\n\n//sections\n.section {\n  padding: clamp(72px, 10vh, 120px) 0;\n  \n  &--hero {\n    min-height: 60vh; display: grid; place-items: center; position: relative; text-align: center;\n    background-image:\n      radial-gradient(1400px 400px at 10% -10%, rgba(255, 210, 0, 0.06), transparent 55%),\n      radial-gradient(1400px 400px at 90% 10%, rgba(193, 18, 31, 0.05), transparent 55%);\n    background-size: auto;\n    background-position: center;\n    @include overlay(0.2);\n    .container { position: relative; z-index: 1; }\n    .eyebrow { \n      margin: 0 0 1rem 0; \n      color: $yellowInk; \n      letter-spacing: .02em;\n      font-size: .95rem; \n      font-family: 'Courier New', monospace;\n      font-weight: 600;\n    }\n    .hero-heading { \n      font-size: clamp(2.5rem, 5vw, 4rem); \n      font-weight: 750; \n      margin: 0 0 1.25rem 0; \n      letter-spacing: -0.03em;\n      line-height: 1.15;\n    }\n    .hero-intro { \n      color: $ink; \n      font-size: clamp(1.05rem, 2vw, 1.2rem); \n      margin: 0 auto 1.5rem; \n      max-width: 70ch;\n      line-height: 1.65;\n    }\n    .hero-badges {\n      display: flex;\n      gap: .75rem;\n      justify-content: center;\n      flex-wrap: wrap;\n      margin-bottom: 2rem;\n    }\n    .hero-actions { display: flex; gap: .75rem; justify-content: center; flex-wrap: wrap; margin-top: 1.25rem; }\n    .hero-pills {\n      display: flex;\n      justify-content: center;\n      gap: .5rem;\n      flex-wrap: wrap;\n      margin-top: .75rem;\n      margin-bottom: 1.25rem;\n    }\n    .hero-pill {\n      display: inline-flex;\n      align-items: center;\n      gap: .45rem;\n      padding: .45rem .75rem;\n      border-radius: 999px;\n      background: rgba(var(--surface-rgb), 0.6);\n      border: 1px solid $border;\n      color: $ink;\n      font-size: .9rem;\n      font-weight: 650;\n\n      i { color: $yellowInk; font-size: .95rem; }\n    }\n    .hero-social {\n      display: flex;\n      gap: 1rem;\n      justify-content: center;\n      flex-wrap: wrap;\n      margin-top: 2rem;\n    }\n  }\n\n  &--alt {\n    background: rgba(var(--surface-rgb), 0.3);\n  }\n\n  &--accent {\n    position: relative;\n    background-image:\n      radial-gradient(1200px 400px at 30% 10%, rgba(255, 210, 0, 0.05), transparent 55%),\n      radial-gradient(900px 350px at 80% 100%, rgba(193, 18, 31, 0.04), transparent 55%);\n    @include overlay(0.4);\n    .container { position: relative; z-index: 1; }\n  }\n}\n\n// Education (streamlined)\n.education-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.25rem;\n  margin-top: 1.5rem;\n\n  @include respond(md) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.edu-item {\n  @include card-base;\n  padding: 1.25rem 1.25rem 1rem;\n  box-shadow: 0 4px 16px $shadow;\n  display: grid;\n  grid-template-columns: 7.5rem 1fr;\n  gap: 1rem;\n  align-items: start;\n\n  @include respond(sm) {\n    grid-template-columns: 1fr;\n    text-align: left;\n  }\n}\n\n.edu-logo-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: .25rem;\n}\n\n.edu-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.edu-school {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: $yellowInk;\n}\n\n.edu-dates {\n  display: inline-flex;\n  align-items: center;\n  padding: .35rem .7rem;\n  border-radius: 999px;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.55);\n  color: $muted;\n  font-size: .9rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.edu-subheader {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: .75rem 1rem;\n  flex-wrap: wrap;\n  margin-top: .45rem;\n}\n\n.edu-degree {\n  color: $ink;\n  font-size: 1rem;\n  font-weight: 650;\n}\n\n.edu-loc {\n  color: $muted;\n  font-size: .95rem;\n  font-weight: 600;\n}\n\n.edu-bullets {\n  margin: .85rem 0 0 1.1rem;\n  color: $ink;\n\n  li {\n    margin: .35rem 0;\n\n    strong {\n      color: $muted;\n      font-weight: 650;\n    }\n  }\n}\n\n.edu-inline-list {\n  display: inline;\n  color: $ink;\n  font-weight: 600;\n}\n\n.edu-sections {\n  margin-top: 1rem;\n  display: grid;\n  gap: 1rem;\n}\n\n.edu-section {\n  border: 1px solid $border;\n  border-radius: .9rem;\n  padding: .9rem;\n  background: rgba(var(--surface-rgb), 0.35);\n}\n\n.edu-section-title {\n  font-size: 0.82rem;\n  font-weight: 800;\n  color: $muted;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: .65rem;\n}\n\n.edu-course-list,\n.edu-teaching-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: .55rem;\n}\n\n.edu-course-list {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n\n  @include respond(sm) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.edu-course-item {\n  display: flex;\n  gap: .6rem;\n  align-items: baseline;\n  min-width: 0;\n}\n\n.edu-course-code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: .9rem;\n  font-weight: 800;\n  color: $ink;\n  white-space: nowrap;\n}\n\n.edu-course-name {\n  color: $ink;\n  font-weight: 650;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-course-grade {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  padding: .2rem .55rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 210, 0, 0.28);\n  background: rgba(255, 210, 0, 0.10);\n  color: $yellowInk;\n  font-size: .82rem;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.edu-teaching-item {\n  color: $ink;\n  font-weight: 650;\n  line-height: 1.5;\n}\n\n.edu-teaching-role {\n  display: inline-flex;\n  align-items: center;\n  padding: .2rem .5rem;\n  border-radius: .5rem;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.55);\n  color: $muted;\n  font-size: .82rem;\n  font-weight: 850;\n  letter-spacing: 0.04em;\n  margin-right: .25rem;\n}\n\n.edu-teaching-course {\n  color: $ink;\n  font-weight: 750;\n}\n\n.edu-teaching-term {\n  color: $muted;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.edu-actions {\n  margin-top: .9rem;\n}\n\n// Modal (Education details)\nbody.modal-open {\n  overflow: hidden;\n}\n\n.modal {\n  position: fixed;\n  inset: 0;\n  z-index: 10060;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding: 1.25rem;\n}\n\n.modal.is-open {\n  display: flex;\n}\n\n.modal-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.modal-panel {\n  position: relative;\n  width: min(920px, 100%);\n  max-height: min(82vh, 760px);\n  display: flex;\n  flex-direction: column;\n  border-radius: 1rem;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.96);\n  backdrop-filter: saturate(120%) blur(12px);\n  box-shadow: 0 18px 55px $shadow;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1rem 0.85rem;\n  border-bottom: 1px solid $border;\n}\n\n.modal-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  color: $ink;\n}\n\n.modal-close {\n  appearance: none;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.55);\n  color: $muted;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: .75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background .2s ease, color .2s ease, border-color .2s ease, transform .06s ease;\n\n  &:hover {\n    background: rgba(255, 210, 0, 0.12);\n    border-color: rgba(255, 210, 0, 0.35);\n    color: $yellowInk;\n  }\n\n  &:active { transform: translateY(1px); }\n  &:focus-visible { outline: 2px solid $yellow; outline-offset: 2px; }\n}\n\n.modal-body {\n  padding: 1rem;\n  overflow: auto;\n}\n\n// Better wrapping inside modal\n.modal {\n  .edu-course-name {\n    overflow: visible;\n    text-overflow: unset;\n    white-space: normal;\n  }\n}\n\n//Section headers\n.section-header { margin: 0 0 2rem 0; }\n.section-title {\n  margin: 0 0 .5rem 0;\n  font-size: clamp(1.5rem, 2.8vw, 2rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  position: relative;\n\n  &::before {\n    content: \"/ \";\n    color: $yellowInk;\n    font-weight: 750;\n  }\n}\n.section-subtitle { margin: 0; color: $muted; max-width: 70ch; font-size: 0.98rem; }\n\n//Buttons\n.btn {\n  display: inline-flex; align-items: center; justify-content: center;\n  gap: .5rem;\n  padding: .75rem 1rem;\n  border-radius: .8rem;\n  text-decoration: none;\n  border: 1px solid $border;\n  background: $surface;\n  color: $ink;\n  font-weight: 650;\n  cursor: pointer;\n  transition: transform .06s ease, background .2s ease, border-color .2s ease, color .2s ease, box-shadow .2s ease;\n  @include btn-hover;\n  &:active { transform: translateY(1px); }\n\n  &--primary {\n    background: $yellow;\n    border-color: $yellow;\n    color: #111;\n    &:hover { background: var(--yellow-hover); border-color: var(--yellow-hover); }\n  }\n\n  &--ghost {\n    background: transparent;\n    &:hover { background: rgba(255, 210, 0, 0.12); border-color: rgba(255, 210, 0, 0.35); color: $yellowInk; }\n  }\n\n  &--small {\n    padding: .5rem .75rem;\n    border-radius: .7rem;\n    font-size: .9rem;\n  }\n}\n\n// Status badges\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: .5rem;\n  padding: .5rem 1rem;\n  border-radius: 999px;\n  background: rgba(var(--surface-rgb), 0.6);\n  border: 1px solid $border;\n  color: $muted;\n  font-size: .9rem;\n  font-weight: 600;\n  \n  &--active {\n    background: rgba(255, 210, 0, 0.12);\n    border-color: rgba(255, 210, 0, 0.3);\n    color: $yellowInk;\n    \n    i {\n      animation: pulse 2s ease-in-out infinite;\n      font-size: .6rem;\n    }\n  }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n// Social links in hero\n.social-link {\n  display: inline-flex;\n  align-items: center;\n  gap: .5rem;\n  padding: .6rem 1rem;\n  border-radius: .7rem;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.6);\n  color: $ink;\n  text-decoration: none;\n  font-size: .95rem;\n  font-weight: 600;\n  transition: background .2s ease, border-color .2s ease, color .2s ease, transform .15s ease;\n  \n  &:hover {\n    background: rgba(255, 210, 0, 0.12);\n    border-color: rgba(255, 210, 0, 0.4);\n    color: $yellow;\n    transform: translateY(-2px);\n  }\n  \n  &:focus-visible {\n    outline: 2px solid $yellow;\n    outline-offset: 2px;\n  }\n  \n  i {\n    font-size: 1.1rem;\n  }\n  \n  span {\n    @include respond(sm) {\n      display: none;\n    }\n  }\n}\n\n//Timeline (Education / Experience)\n.timeline { display: grid; gap: 1rem; margin-top: 1.5rem; }\n.timeline-item { @include card-base; padding: 1.25rem 1.25rem 1rem; box-shadow: 0 4px 16px $shadow; }\n.timeline-top { display: flex; justify-content: space-between; align-items: baseline; gap: 1rem; flex-wrap: wrap; }\n.timeline-title { margin: 0; font-size: 1.2rem; font-weight: 700; color: $yellowInk; }\n.timeline-degree {\n  margin: .5rem 0 0 0;\n  color: $ink;\n  font-size: 1rem;\n  font-weight: 600;\n}\n.timeline-meta { color: $muted; font-size: .95rem; }\n.timeline-bullets { \n  margin: .85rem 0 0 1.1rem; \n  color: $ink; \n  li { \n    margin: .35rem 0;\n    strong {\n      color: $muted;\n      font-weight: 650;\n    }\n  } \n}\n\n// Logo/Image placeholders for Education\n.timeline-logo {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n  padding: .25rem;\n  background: transparent;\n  border-radius: 0.75rem;\n  border: 0;\n}\n\n.edu-logo {\n  max-width: 120px;\n  height: 80px;\n  object-fit: contain;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  filter: none;\n  transition: transform 0.2s ease;\n  \n  .timeline-item:hover &,\n  .edu-item:hover & {\n    transform: scale(1.05);\n  }\n}\n\n// Education grid layout\n.timeline--grid {\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.25rem;\n  \n  @include respond(md) {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Logo/Image for Experience\n.experience-logo {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 0.75rem;\n  padding: .25rem;\n  background: transparent;\n  border-radius: 0.5rem;\n  border: 0;\n  width: fit-content;\n}\n\n.company-logo {\n  max-width: 100px;\n  height: 50px;\n  object-fit: contain;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  filter: none;\n  transition: transform 0.2s ease;\n  \n  .timeline-main:hover & {\n    transform: scale(1.05);\n  }\n}\n\n// About section\n.about-content {\n  max-width: 70ch;\n  margin: 0 auto;\n  \n  p {\n    font-size: 1.05rem;\n    line-height: 1.75;\n    margin: 0 0 1.25rem 0;\n    color: $ink;\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// Split timeline variant (Experience): date/location on left, card on right\n.timeline--split {\n  --timeline-line: rgba(255, 210, 0, 0.22);\n  --timeline-dot: #{$yellow};\n  --timeline-dot-ring: rgba(255, 210, 0, 0.14);\n  --meta-col: 12.5rem;\n  --axis-x: calc(var(--meta-col) + 1.25rem);\n\n  position: relative;\n  gap: 1.25rem;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: .5rem;\n    bottom: .5rem;\n    left: var(--axis-x);\n    width: 2px;\n    border-radius: 2px;\n    background: linear-gradient(to bottom, transparent, var(--timeline-line) 10%, var(--timeline-line) 90%, transparent);\n  }\n\n  .timeline-item {\n    // override base card styling for this variant\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n\n    display: grid;\n    grid-template-columns: var(--meta-col) 1fr;\n    column-gap: 2.5rem;\n    align-items: start;\n    position: relative;\n\n    &::before,\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 1.1rem;\n      left: var(--axis-x);\n      transform: translateX(-50%);\n      border-radius: 999px;\n      pointer-events: none;\n    }\n\n    &::before {\n      width: 10px;\n      height: 10px;\n      background: var(--timeline-dot);\n      box-shadow: 0 0 0 1px rgba(17, 17, 17, 0.22);\n      z-index: 2;\n    }\n\n    &::after {\n      width: 30px;\n      height: 30px;\n      transform: translate(-50%, -10px);\n      background: radial-gradient(circle at center, var(--timeline-dot-ring), transparent 70%);\n      z-index: 1;\n    }\n  }\n\n  .timeline-side {\n    padding-top: .25rem;\n    color: $muted;\n    font-size: .95rem;\n    line-height: 1.35;\n  }\n  .timeline-date { font-weight: 650; color: $ink; letter-spacing: -0.01em; }\n  .timeline-loc { margin-top: .25rem; }\n\n  .timeline-main {\n    @include card-base;\n    padding: 1.25rem 1.25rem 1rem;\n    box-shadow: 0 4px 16px $shadow;\n\n    // Scroll reveal defaults (JS adds .is-visible)\n    opacity: 0;\n    transform: translateY(10px);\n    transition: opacity .55s ease, transform .55s ease;\n\n    &.is-visible {\n      opacity: 1;\n      transform: none;\n    }\n  }\n\n  .timeline-role { margin: 0; font-size: 1.1rem; font-weight: 700; }\n  .timeline-org { margin-top: .25rem; color: $muted; font-size: .98rem; }\n\n  @media (prefers-reduced-motion: reduce) {\n    .timeline-main { opacity: 1; transform: none; transition: none; }\n  }\n\n  @include respond(sm) {\n    --meta-col: 0rem;\n    --axis-x: 1.1rem;\n\n    padding-left: 2.25rem;\n\n    &::before { left: var(--axis-x); }\n\n    .timeline-item {\n      grid-template-columns: 1fr;\n      row-gap: .6rem;\n    }\n\n    .timeline-side { color: $muted; }\n    .timeline-date { color: $ink; }\n  }\n}\n\n// Projects grid (3 columns)\n.projects-grid {\n  display: grid;\n  gap: 1.25rem;\n  margin-top: 1.75rem;\n  grid-template-columns: repeat(3, 1fr);\n\n  .project-card {\n    @include card-base;\n    padding: 0;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    overflow: hidden;\n  }\n\n  @media (max-width: 1100px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  @include respond(md) {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Project image placeholder\n.project-image {\n  width: 100%;\n  height: 200px;\n  background: rgba(255, 210, 0, 0.05);\n  border-bottom: 1px solid $border;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n  \n  &::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.28), transparent 55%);\n    pointer-events: none;\n  }\n}\n\n.projects-grid .project-kicker {\n  display: inline-flex;\n  width: fit-content;\n  margin-top: 1.25rem;\n  background: rgba(255, 210, 0, 0.12);\n  border: 1px solid rgba(255, 210, 0, 0.22);\n  color: $yellowInk;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  font-weight: 750;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.projects-grid .project-subtitle {\n  color: $muted;\n  font-size: 0.98rem;\n  margin-bottom: 1rem;\n}\n\n.projects-grid .project-tags li {\n  background: rgba(var(--surface-rgb), 0.6);\n  color: $muted;\n}\n\n.projects-grid .project-links {\n  margin-top: auto;\n}\n\n.project-thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease, filter 0.3s ease;\n  \n  .project-card:hover & {\n    transform: scale(1.05);\n    filter: brightness(1.1);\n  }\n}\n\n// Update project card content padding\n.project-card {\n  .project-kicker,\n  .project-title,\n  .project-subtitle,\n  .project-description,\n  .project-tags,\n  .project-links {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  \n  .project-kicker {\n    margin-top: 1.5rem;\n  }\n  \n  .project-links {\n    padding-bottom: 1.25rem;\n  }\n}\n\n.project-tags {\n  list-style: none;\n  padding: 0;\n  margin: 1rem 0 0;\n  display: flex;\n  gap: .5rem;\n  flex-wrap: wrap;\n\n  li {\n    border: 1px solid $border;\n    background: rgba(255, 210, 0, 0.06);\n    color: $muted;\n    padding: .25rem .55rem;\n    border-radius: 999px;\n    font-size: .85rem;\n  }\n}\n\n.projects-footer {\n  margin-top: 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n\n// Skills section - Compact inline layout\n.skills-compact {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.75rem;\n\n  @include respond(md) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.skill-category-inline {\n  @include card-base;\n  padding: 1.5rem;\n  box-shadow: 0 4px 16px $shadow;\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n  height: 100%;\n  \n  @include respond(sm) {\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n.skill-icon {\n  flex-shrink: 0;\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(255, 210, 0, 0.15), rgba(255, 210, 0, 0.05));\n  border: 2px solid rgba(255, 210, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  i {\n    font-size: 1.5rem;\n    color: $yellow;\n  }\n}\n\n.skill-content {\n  flex: 1;\n  min-width: 0;\n  \n  h3 {\n    margin: 0 0 1rem 0;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: $ink;\n  }\n}\n\n.skill-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  align-content: flex-start;\n  min-width: 0;\n}\n\n.skill-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.5rem 0.9rem;\n  background: rgba(var(--surface-rgb), 0.6);\n  border: 1px solid $border;\n  border-radius: 999px;\n  color: $ink;\n  font-size: 0.9rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  \n  i {\n    font-size: 1rem;\n    color: $yellow;\n  }\n  \n  &:hover {\n    background: rgba(255, 210, 0, 0.1);\n    border-color: rgba(255, 210, 0, 0.3);\n    transform: translateY(-2px);\n  }\n}\n\n//Carousel\n.carousel-container { position: relative; margin-top: 3rem; max-width: 800px; margin: 3rem auto 0; }\n.carousel-wrapper { position: relative; overflow: hidden; border-radius: 1rem; @include card-base; box-shadow: 0 4px 20px $shadow; }\n.carousel-track { display: flex; transition: transform 0.5s ease-in-out; }\n.carousel-slide {\n  min-width: 100%; flex-shrink: 0; padding: 3rem 2rem; display: none; position: relative;\n  background-image:\n    radial-gradient(900px 300px at 30% 0%, rgba(255, 210, 0, 0.05), transparent 55%),\n    radial-gradient(900px 300px at 90% 100%, rgba(193, 18, 31, 0.04), transparent 55%);\n  background-size: auto;\n  background-position: center;\n  &.active { display: block; }\n  @include overlay(0.25);\n  .project-card { position: relative; z-index: 2; }\n}\n\n.project-card { margin: 0; }\n.project-kicker { display: inline-block; background: $yellow; color: #111; padding: 0.45rem 0.9rem; border-radius: 2rem; font-weight: 700; font-size: 0.8rem; margin-bottom: 1.25rem; text-transform: uppercase; letter-spacing: 0.1em; }\n.project-title { color: $yellowInk; font-size: 1.45rem; font-weight: 750; margin: 0 0 .65rem 0; line-height: 1.25; letter-spacing: -0.02em; }\n.project-subtitle { color: $muted; font-size: 1.05rem; margin: 0 auto 1.5rem; max-width: 58ch; }\n.project-description { color: $ink; line-height: 1.7; font-size: 1rem; margin: 0 auto 1.75rem; max-width: 70ch; text-align: left; }\n.projects-grid .project-description {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.project-links { display: flex; justify-content: flex-start; gap: .75rem; flex-wrap: wrap; margin-top: auto; padding-top: 1.1rem; }\n\n.carousel-btn {\n  position: absolute; top: 50%; transform: translateY(-50%); @include flex-center;\n  background: rgba(var(--surface-rgb), 0.9); border: 1px solid $border; color: $ink;\n  width: 3rem; height: 3rem; border-radius: 50%; cursor: pointer; font-size: 1.5rem; font-weight: bold;\n  transition: all 0.3s ease; z-index: 10;\n  &:hover { background: $yellow; color: #111; border-color: $yellow; transform: translateY(-50%) scale(1.1); }\n  &:focus-visible { outline: 2px solid $yellow; outline-offset: 2px; }\n  &--prev { left: -1.5rem; }\n  &--next { right: -1.5rem; }\n  @include respond(md) {\n    width: 2.5rem; height: 2.5rem; font-size: 1.2rem;\n    &--prev { left: -1.25rem; }\n    &--next { right: -1.25rem; }\n  }\n}\n\n.carousel-indicators { display: flex; justify-content: center; gap: 0.5rem; margin-top: 2rem; }\n.carousel-indicator {\n  width: 12px; height: 12px; border-radius: 50%; border: 2px solid $muted; background: transparent; cursor: pointer; transition: all 0.3s ease;\n  &:hover { border-color: $yellow; background: rgba(255, 210, 0, 0.3); }\n  &.active { background: $yellow; border-color: $yellow; }\n  &:focus-visible { outline: 2px solid $yellow; outline-offset: 2px; }\n}\n\n//Contact\n.site-footer { \n  padding: 2rem 0; \n  color: $muted; \n  text-align: center; \n  background: $surface; \n  border-top: 1px solid $border;\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  small {\n    order: 2;\n  }\n}\n\n// Footer social icons\n.footer-social {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  order: 1;\n  \n  a {\n    @include flex-center;\n    width: 2.75rem;\n    height: 2.75rem;\n    border-radius: 50%;\n    background: transparent;\n    border: 1px solid $border;\n    color: $ink;\n    text-decoration: none;\n    font-size: 1.1rem;\n    transition: all .2s ease;\n    \n    &:hover {\n      background: rgba(255, 210, 0, 0.12);\n      border-color: rgba(255, 210, 0, 0.4);\n      color: $yellow;\n      transform: translateY(-2px);\n    }\n    \n    &:focus-visible {\n      outline: 2px solid $yellow;\n      outline-offset: 2px;\n    }\n  }\n}\n.contact-content {\n  text-align: center; max-width: 800px; margin: 0 auto;\n  h2 { \n    color: $yellowInk; \n    font-size: clamp(1.8rem, 3.5vw, 2.5rem); \n    margin: 0 0 1.5rem 0; \n    font-weight: 750; \n    letter-spacing: -0.02em;\n    line-height: 1.3;\n  }\n  .contact-intro { font-size: 1.05rem; line-height: 1.65; margin: 0 0 2.5rem 0; color: $ink; }\n}\n\n// Unified contact card\n.contact-card-unified {\n  @include card-base;\n  padding: 2rem;\n  box-shadow: 0 8px 32px $shadow;\n  text-align: left;\n}\n\n.contact-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem 2rem;\n  margin-bottom: 2rem;\n  \n  @include respond(sm) {\n    grid-template-columns: 1fr;\n    gap: 1.25rem;\n  }\n}\n\n.contact-info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  \n  i {\n    font-size: 1.4rem;\n    color: $yellow;\n    margin-top: 0.2rem;\n    flex-shrink: 0;\n  }\n  \n  h3 {\n    margin: 0 0 0.35rem 0;\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: $muted;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  a, p {\n    margin: 0;\n    color: $ink;\n    font-size: 1rem;\n    font-weight: 600;\n    text-decoration: none;\n    transition: color 0.2s ease;\n    \n    &:hover {\n      color: $yellow;\n    }\n  }\n  \n  p {\n    color: $ink;\n  }\n}\n\n.contact-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: .5rem;\n  flex-wrap: wrap;\n}\n\n.contact-email-copy {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: $ink;\n  cursor: pointer;\n  font: inherit;\n  font-size: 1rem;\n  font-weight: 650;\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 3px;\n  text-decoration-color: rgba(255, 210, 0, 0.4);\n  transition: color .2s ease, text-decoration-color .2s ease, transform .06s ease;\n\n  &:hover {\n    color: $yellow;\n    text-decoration-color: rgba(255, 210, 0, 0.9);\n  }\n\n  &:active { transform: translateY(1px); }\n  &:focus-visible { outline: 2px solid $yellow; outline-offset: 2px; }\n}\n\n// Toast popup (global)\n.toast {\n  position: fixed;\n  left: 50%;\n  bottom: 1.25rem;\n  transform: translateX(-50%) translateY(10px);\n  z-index: 10050;\n  padding: .75rem 1rem;\n  border-radius: .9rem;\n  border: 1px solid $border;\n  background: rgba(var(--surface-rgb), 0.92);\n  backdrop-filter: saturate(120%) blur(10px);\n  color: $ink;\n  font-weight: 650;\n  box-shadow: 0 10px 35px $shadow;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity .18s ease, transform .18s ease;\n\n  &.is-visible {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n\n  @include respond(sm) {\n    width: min(520px, calc(100% - 2rem));\n    text-align: center;\n  }\n}\n\n// Remove old contact styles\n.contact-methods,\n.contact-method,\n.contact-icon-links,\n.contact-icon-link,\n.contact-card {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
